import React from "react";
import { isLoggedIn } from "./api";
import { AccountLayout } from "./components/AccountLayout";
import { AgentEditorLayout } from "./components/AgentEditorLayout";
import { LoginPage } from "./pages/LoginPage";
import { SignupPage } from "./pages/SignupPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AgentSettingsPage } from "./pages/AgentSettingsPage";
import { PersonalityPage } from "./pages/PersonalityPage";
import { IntegrationsPage } from "./pages/IntegrationsPage";
import { SourcesPage } from "./pages/SourcesPage";
import { ConversationsPage } from "./pages/ConversationsPage";
import { ChatsPage } from "./pages/ChatsPage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { DangerZonePage } from "./pages/DangerZonePage";
import { UserSettingsPage } from "./pages/UserSettingsPage";
import "./index.css";

export function App() {
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "/";

  // Public routes — redirect to dashboard if already logged in
  if (pathname === "/login" || pathname === "/signup") {
    if (isLoggedIn()) {
      window.location.href = "/dashboard";
      return null;
    }
    return pathname === "/login" ? <LoginPage /> : <SignupPage />;
  }

  // Protected routes — redirect to login if not authenticated
  if (!isLoggedIn()) {
    window.location.href = "/login";
    return null;
  }

  // Redirect old URLs to new ones
  const oldSettingsMatch = pathname.match(/^\/agents\/([a-f0-9-]+)\/settings$/);
  if (oldSettingsMatch) {
    window.location.href = `/agents/${oldSettingsMatch[1]}/general`;
    return null;
  }
  const oldSourcesMatch = pathname.match(/^\/agents\/([a-f0-9-]+)\/sources$/);
  if (oldSourcesMatch) {
    window.location.href = `/agents/${oldSourcesMatch[1]}/knowledge`;
    return null;
  }
  const oldConversationsMatch = pathname.match(/^\/agents\/([a-f0-9-]+)\/conversations$/);
  if (oldConversationsMatch) {
    window.location.href = `/agents/${oldConversationsMatch[1]}/chats`;
    return null;
  }

  // /agents/:id (no sub-path) -> redirect to general
  const agentOnlyMatch = pathname.match(/^\/agents\/([a-f0-9-]+)$/);
  if (agentOnlyMatch) {
    window.location.href = `/agents/${agentOnlyMatch[1]}/general`;
    return null;
  }

  // Agent editor routes (wrapped in AgentEditorLayout)
  const generalMatch = pathname.match(/^\/agents\/([a-f0-9-]+)\/general$/);
  if (generalMatch) {
    return (
      <AgentEditorLayout agentId={generalMatch[1]}>
        <AgentSettingsPage agentId={generalMatch[1]} />
      </AgentEditorLayout>
    );
  }

  const knowledgeMatch = pathname.match(/^\/agents\/([a-f0-9-]+)\/knowledge$/);
  if (knowledgeMatch) {
    return (
      <AgentEditorLayout agentId={knowledgeMatch[1]}>
        <SourcesPage agentId={knowledgeMatch[1]} />
      </AgentEditorLayout>
    );
  }

  const personalityMatch = pathname.match(/^\/agents\/([a-f0-9-]+)\/personality$/);
  if (personalityMatch) {
    return (
      <AgentEditorLayout agentId={personalityMatch[1]}>
        <PersonalityPage agentId={personalityMatch[1]} />
      </AgentEditorLayout>
    );
  }

  const integrationsMatch = pathname.match(/^\/agents\/([a-f0-9-]+)\/integrations$/);
  if (integrationsMatch) {
    return (
      <AgentEditorLayout agentId={integrationsMatch[1]}>
        <IntegrationsPage agentId={integrationsMatch[1]} />
      </AgentEditorLayout>
    );
  }

  const chatsMatch = pathname.match(/^\/agents\/([a-f0-9-]+)\/chats$/);
  if (chatsMatch) {
    return (
      <AgentEditorLayout agentId={chatsMatch[1]}>
        <ChatsPage agentId={chatsMatch[1]} />
      </AgentEditorLayout>
    );
  }

  const analyticsMatch = pathname.match(/^\/agents\/([a-f0-9-]+)\/analytics$/);
  if (analyticsMatch) {
    return (
      <AgentEditorLayout agentId={analyticsMatch[1]}>
        <AnalyticsPage agentId={analyticsMatch[1]} />
      </AgentEditorLayout>
    );
  }

  const dangerMatch = pathname.match(/^\/agents\/([a-f0-9-]+)\/danger$/);
  if (dangerMatch) {
    return (
      <AgentEditorLayout agentId={dangerMatch[1]}>
        <DangerZonePage agentId={dangerMatch[1]} />
      </AgentEditorLayout>
    );
  }

  // User settings page
  if (pathname === "/settings") {
    return (
      <AccountLayout>
        <UserSettingsPage />
      </AccountLayout>
    );
  }

  // Default: dashboard
  return (
    <AccountLayout>
      <DashboardPage />
    </AccountLayout>
  );
}

export default App;
